// Sidebar navigation. Add new routes here.
//   showWhen: hides a group or item unless the flag is true (see Sidebar):
//             "employee" | "admin" | "evaluator"
//   badge:    key of a count shown next to the item (see Sidebar)
export const NAV_CONFIG = {
  main: [
    { path: "/me", label: "Dashboard", icon: "bi-speedometer2" },
    {
      path: "/me/profile",
      label: "My Profile",
      icon: "bi-person-badge",
      showWhen: "employee",
    },
    {
      path: "/me/leaves",
      label: "My Leaves",
      icon: "bi-calendar-check",
      showWhen: "employee",
      badge: "pendingLeaves",
    },
    {
      path: "/me/assets",
      label: "My Assets",
      icon: "bi-laptop",
      showWhen: "employee",
      badge: "assetsToAcknowledge",
    },
    {
      path: "/me/learning",
      label: "My Learning",
      icon: "bi-mortarboard",
      showWhen: "employee",
    },
  ],
  groups: [
    {
      key: "attendance",
      label: "My Time",
      icon: "bi-clock-history",
      // DTR History is a button on My DTR (no separate menu item)
      items: [
        { path: "/me/attendance", label: "Check-in & Attendance" },
        {
          path: "/me/dtr",
          label: "My DTR",
          showWhen: "employee",
        },
        { path: "/me/overtime", label: "My Overtime", showWhen: "employee" },
        {
          path: "/me/client-visits",
          label: "Client Visits",
          showWhen: "clientVisits",
        },
      ],
    },
    {
      key: "performance",
      label: "Performance",
      icon: "bi-graph-up-arrow",
      items: [
        {
          path: "/me/evaluations",
          label: "My Evaluations",
          showWhen: "employee",
          badge: "evaluationActions",
        },
        {
          path: "/me/evaluations-to-rate",
          label: "Evaluations to Rate",
          showWhen: "evaluator",
          badge: "evaluationsToRate",
        },
      ],
    },
  ],
};
